module.exports = "<p>\n    Your query did not return any results. Please refine your search parameters and try again.\n</p>\n"